import React, { useEffect, useState } from "react";
import { MdKeyboardArrowLeft } from "react-icons/md";
import TabsSection from "../../Components/Tabs/TabsSection";
import SideBar from "../SideBar/SideBar";
import CouponsDashboard from "./CouponsDashboard";
import ManageCoupons from "./ManageCoupons";
import { Link } from "react-router-dom";
import BackButton from "../BackButton/BackButton";
import { FeaturedCoupons } from "./FeaturedCoupons";
import PrivacyTermsConditions from "../PrivacyTermsConditions/PrivacyTermsConditions";
import  { MyCoupons } from "./MyCoupons";
import BussinessListing from "./BussinessListing";

const Coupons = () => {
  const [title, setTitle] = useState("");
  const [currentTab, setcurrentTab] = useState("");
  const [loading, setLoading] = useState(false);

  const path = window.location.href;
  const endPath = path.split("/");

  useEffect(() => {
    const url = endPath[4].replace(/-/g, " ");
    const arr = url.split(" ");

    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }

    setTitle(arr.join(" "));

    if (endPath[4] === "coupons-dashboard") {
      setcurrentTab("coupons-dashboard");
    }

    if (endPath[4] === "manage-coupons") {
      setcurrentTab("manage-coupons");
    }

    if (endPath[4] === "featured-coupons") {
      setcurrentTab("featured-coupons");
    }

    if (endPath[4] === "my-coupons") {
      setcurrentTab("my-coupons");
    }
    if (endPath[4] === "bussiness-listing") {
      setcurrentTab("bussiness-listing");
    }
  }, [path]);

  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">Coupons</p>
          <div className="acc-dashboard mt-4">
            <TabsSection />

            {currentTab == "coupons-dashboard" && <CouponsDashboard />}

            {currentTab == "manage-coupons" && <ManageCoupons />}

            {currentTab == "featured-coupons" && (
              <FeaturedCoupons loading={loading} setLoading={setLoading} />
            )}
            {currentTab === "my-coupons" && <MyCoupons />}

            {currentTab === "bussiness-listing" && <BussinessListing />}
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default Coupons;
